/**
 * Art Wall Studio — print size catalog & upload resolution rules
 */
(function () {
  'use strict';

  var CATALOG_MIN_SHORT_EDGE = 1000;
  var IMAGE_SQUARE_RATIO_TOLERANCE = 0.04;

  var USIPIC_MIN_SHORT_EDGE_PX = {
    '16x16': 1600,
    '20x20': 2000,
    '24x24': 2400,
    '10x8': 1000,
    '10x08': 1000,
    '8x10': 1000,
    '16x12': 1600,
    '12x16': 1600,
    '18x12': 1800,
    '12x18': 1800,
    '20x16': 2000,
    '16x20': 2000,
    '24x12': 2400,
    '12x24': 2400,
    '24x16': 2400,
    '16x24': 2400,
    '24x20': 2400,
    '20x24': 2400,
    '30x16': 3000,
    '16x30': 3000,
    '30x20': 3000,
    '20x30': 3000,
    '30x24': 3000,
    '24x30': 3000,
    '32x18': 3200,
    '18x32': 3200,
    '36x18': 3600,
    '18x36': 3600,
    '36x24': 3600,
    '24x36': 3600,
    '35x28': 3500,
    '28x35': 3500,
    '40x30': 4000,
    '30x40': 4000,
    '40x32': 4000,
    '32x40': 4000,
  };

  var SQUARE_SIZES = [
    [16, 16],
    [20, 20],
    [24, 24],
  ];

  var LANDSCAPE_SIZES = [
    [10, 8],
    [16, 12],
    [18, 12],
    [20, 16],
    [24, 12],
    [24, 16],
    [24, 20],
    [30, 16],
    [30, 20],
    [30, 24],
    [32, 18],
    [36, 18],
    [36, 24],
    [35, 28],
    [40, 30],
    [40, 32],
  ];

  function normSize(s) {
    var p = String(s || '').replace(/\s+/g, '').toLowerCase().split('x');
    if (p.length !== 2) return String(s || '').replace(/\s+/g, '').toLowerCase();
    var a = parseInt(p[0], 10);
    var b = parseInt(p[1], 10);
    if (isNaN(a) || isNaN(b)) return String(s || '').replace(/\s+/g, '').toLowerCase();
    return (a <= b ? a : b) + 'x' + (a <= b ? b : a);
  }

  function sizeMatchKeys(size) {
    var p = String(size || '').replace(/\s+/g, '').toLowerCase().split('x');
    if (p.length !== 2) return [normSize(size)];
    var w = parseInt(p[0], 10);
    var h = parseInt(p[1], 10);
    if (isNaN(w) || isNaN(h)) return [normSize(size)];
    var pad = function (n) {
      return n < 10 ? '0' + n : String(n);
    };
    var keys = {};
    keys[normSize(size)] = true;
    keys[w + 'x' + h] = true;
    keys[h + 'x' + w] = true;
    keys[w + 'x' + pad(h)] = true;
    keys[pad(w) + 'x' + pad(h)] = true;
    keys[h + 'x' + pad(w)] = true;
    keys[pad(h) + 'x' + pad(w)] = true;
    keys[pad(w) + 'x' + h] = true;
    return Object.keys(keys);
  }

  function sizeOrientationFromParts(w, h) {
    if (w === h) return 'square';
    return w < h ? 'portrait' : 'landscape';
  }

  function makeSizeEntry(w, h, ratio) {
    return {
      id: w + 'x' + h,
      width: w,
      height: h,
      ratio: ratio,
      basePrice: 0,
    };
  }

  function buildSizeCatalog() {
    var catalog = [];
    var i;
    for (i = 0; i < SQUARE_SIZES.length; i++) {
      catalog.push(makeSizeEntry(SQUARE_SIZES[i][0], SQUARE_SIZES[i][1], 'square'));
    }
    for (i = 0; i < LANDSCAPE_SIZES.length; i++) {
      var lw = LANDSCAPE_SIZES[i][0];
      var lh = LANDSCAPE_SIZES[i][1];
      catalog.push(makeSizeEntry(lw, lh, 'landscape'));
      if (lw !== lh) {
        catalog.push(makeSizeEntry(lh, lw, 'portrait'));
      }
    }
    return catalog;
  }

  var CATALOG_SIZES = buildSizeCatalog();

  function getMinShortEdgePx(size) {
    var keys = sizeMatchKeys(size);
    for (var i = 0; i < keys.length; i++) {
      if (Object.prototype.hasOwnProperty.call(USIPIC_MIN_SHORT_EDGE_PX, keys[i])) {
        return USIPIC_MIN_SHORT_EDGE_PX[keys[i]];
      }
    }
    return null;
  }

  function validateImageShortEdge(imageW, imageH, size) {
    var minPx = getMinShortEdgePx(size);
    var shortPx = Math.min(Number(imageW) || 0, Number(imageH) || 0);
    if (!minPx) return { ok: true, minPx: null, shortPx: shortPx };
    return { ok: shortPx >= minPx, minPx: minPx, shortPx: shortPx };
  }

  function imageOrientationFromDimensions(w, h) {
    if (!w || !h) return 'landscape';
    var ratio = w / h;
    if (ratio >= 1 - IMAGE_SQUARE_RATIO_TOLERANCE && ratio <= 1 + IMAGE_SQUARE_RATIO_TOLERANCE) {
      return 'square';
    }
    return w < h ? 'portrait' : 'landscape';
  }

  function parseSizeEntry(entry) {
    if (!entry) return null;
    return {
      id: entry.id,
      w: entry.width,
      h: entry.height,
      ratio: entry.ratio,
      area: entry.width * entry.height,
      aspect: entry.width / entry.height,
    };
  }

  function isSizeAvailable(imageW, imageH, sizeId) {
    if (!imageW || !imageH) return true;
    return validateImageShortEdge(imageW, imageH, sizeId).ok;
  }

  function imageTooSmallMessage(shortPx) {
    return (
      'Image resolution too low (short edge ' +
      shortPx +
      'px, minimum ' +
      CATALOG_MIN_SHORT_EDGE +
      'px). Please upload a higher-resolution image.'
    );
  }

  function hasAnyAvailableSize(catalog, imageW, imageH) {
    if (!imageW || !imageH) return true;
    for (var i = 0; i < catalog.length; i++) {
      if (isSizeAvailable(imageW, imageH, catalog[i].id)) return true;
    }
    return false;
  }

  function pickBestSize(catalog, imageW, imageH, ratioTab, requireOrientation) {
    if (!catalog || !catalog.length || !imageW || !imageH) return null;
    var targetOrientation = ratioTab || imageOrientationFromDimensions(imageW, imageH);
    var best = null;
    var bestArea = -1;

    for (var i = 0; i < catalog.length; i++) {
      var entry = catalog[i];
      if (!isSizeAvailable(imageW, imageH, entry.id)) continue;
      if (requireOrientation && entry.ratio !== targetOrientation) continue;
      var area = entry.width * entry.height;
      if (area > bestArea) {
        bestArea = area;
        best = entry;
      }
    }
    return best;
  }

  function pickBestSizeForUpload(catalog, imageW, imageH) {
    var orient = imageOrientationFromDimensions(imageW, imageH);
    var best = pickBestSize(catalog, imageW, imageH, orient, true);
    if (!best) best = pickBestSize(catalog, imageW, imageH, orient, false);
    return best;
  }

  function measureImageDimensionsFromSrc(src) {
    return new Promise(function (resolve, reject) {
      var im = new Image();
      im.onload = function () {
        resolve({
          w: im.naturalWidth || im.width || 0,
          h: im.naturalHeight || im.height || 0,
        });
      };
      im.onerror = function () {
        reject(new Error('Could not read image dimensions.'));
      };
      im.src = src;
    });
  }

  window.__USIPIC_ART_WALL_SIZE_RULES__ = {
    CATALOG_MIN_SHORT_EDGE: CATALOG_MIN_SHORT_EDGE,
    USIPIC_MIN_SHORT_EDGE_PX: USIPIC_MIN_SHORT_EDGE_PX,
    CATALOG_SIZES: CATALOG_SIZES,
    buildSizeCatalog: buildSizeCatalog,
    getMinShortEdgePx: getMinShortEdgePx,
    validateImageShortEdge: validateImageShortEdge,
    imageOrientationFromDimensions: imageOrientationFromDimensions,
    isSizeAvailable: isSizeAvailable,
    hasAnyAvailableSize: hasAnyAvailableSize,
    pickBestSize: pickBestSize,
    pickBestSizeForUpload: pickBestSizeForUpload,
    imageTooSmallMessage: imageTooSmallMessage,
    measureImageDimensionsFromSrc: measureImageDimensionsFromSrc,
  };
})();
